import React from "react";
import { Card, Divider } from "../../../ecosystem";
import SummaryItem from "./SummaryItem";

const SummaryItemGroup = ({
    children, // Can manually manage summary items with children
    summaryItems, // OR pass in array of item array with title and info data for component to map
}) => {

    return (
        <div className="care-gaps-summary-item-group">
            <Card>
                {children
                    ? <>
                        {children}
                    </>
                    : <>
                        {summaryItems && summaryItems.length > 0 &&
                            summaryItems.map((item, index) => {
                                return <React.Fragment key={index}>
                                    <SummaryItem
                                        data-key={index}
                                        title={item?.title}
                                        info={item?.info}
                                        fileName={item?.fileName}
                                        fileSize={item?.fileSize}
                                        variant={item?.variant}
                                    />
                                    {(index < summaryItems.length - 1) && <Divider mLeft="none" mRight="none" mTop="small" mBottom="small" />}
                                </React.Fragment>
                            })}
                    </>
                }
            </Card>
        </div>
    );
};

export default SummaryItemGroup;